<script>
    window.scrollTo(0, 0);

    import {push} from "svelte-spa-router";
    import {API_URL, TRANSPORT_COST_MAXIMUM_DIAMETER, TRANSPORT_COST_PER_PIECE} from "../../../env";
    import {shoppingCart} from "../../js/stores";
    import Product from "../../components/cart/Product.svelte";
    import Error from "../../placeholders/Error.svelte";
    import OrderHeader from "./OrderHeader.svelte";
    import ContentLoading from '../../placeholders/ContentLoading.svelte';

    // if ($shoppingCart.length === 0) push('/')   // Když je prázdný košík, nelze se na stránku dostat

    export let data = fetchData()

    export let transportCost = 0
    export let transportCostWillBeChanged = false

    export let transportMethod = undefined
    getTransportMethod()

    $: updateTransportMethod(transportMethod)

    async function fetchData() {
        let res1 = await fetch(API_URL + '/shoppingCart', {
            method: 'GET',
            credentials: "include",
        })

        if (!res1.ok) return console.error('Fetch error!', await res1.json());

        let cartItems = await res1.json()

        let ids = cartItems.map(v => v.product_id);

        // Second fetch => fetching products info
        const res2 = await fetch(API_URL + '/products/' + ids.join(','))

        if (!res2.ok) return console.error('Fetch error!', await res2.json());

        let products = await res2.json()

        cartItems.forEach(element => {
            element.product = products.find(v => v.id === element.product_id)
            if (element.product.diameter <= TRANSPORT_COST_MAXIMUM_DIAMETER) {
                transportCost += (TRANSPORT_COST_PER_PIECE * element.amount)
            }
            else {
                transportCostWillBeChanged = true
            }
        })

        shoppingCart.set(cartItems)
        return cartItems
    }

    function calculatePrice(data, method) {
        let price = 0

        transportCost = 0

        data.forEach((row) => {
            price += row.price * row.amount
            if (row.product.diameter <= TRANSPORT_COST_MAXIMUM_DIAMETER) {
                transportCost += (TRANSPORT_COST_PER_PIECE * row.amount)
            }
            else {
                transportCostWillBeChanged = true
            }
        })

        if (method) {
            price += transportCost
        }

        sessionStorage.setItem("total_price", price.toFixed(2))

        return price.toFixed(2)
    }

    /******************************************************************/

    async function updateTransportMethod(method) {
        if (typeof method != "boolean") return;

        let body = {
            delivery: method
        }

        const res = await fetch(API_URL + '/shoppingCart/delivery/set', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            alert ('Pri výbere metódy dopravy nastala chyba. Skúste to znova.')
            transportMethod = undefined
            sessionStorage.removeItem('transportMethodInPerson');
            return;
        }

        sessionStorage.setItem('transportMethodInPerson', !method);
    }

    async function getTransportMethod() {
        const res = await fetch(API_URL + '/shoppingCart/delivery/get', {
            method: 'GET',
            credentials: 'include',
        })

        let body = await res.json()

        transportMethod = body?.delivery

        sessionStorage.setItem('transportMethodInPerson', !transportMethod);
    }

    /*******************************/

    function handleRemoveProduct(e) {
        Promise.resolve(data).then((resolved) => {
            data = resolved.filter(v => v.id !== e.detail.id)
        })
    }
</script>

<section class="container">
    {#await data}
        <ContentLoading/>
    {:then data}
        <div class="order">
            <div class="row d-flex justify-content-center">
                <div class="col-lg-10 col-xl-8 col-xxl-6">

                    <OrderHeader step={1}/>

                    <div class="order-body">
                        <div class="order-products">
                            {#each data as row}
                                <Product
                                    data={row}
                                    on:removeItem={handleRemoveProduct}
                                />
                            {/each}
                        </div>
                    </div>

                    <div class="order-delivery">
                        <h2>Doprava</h2>
                        <ul>
                            <li class:focused={transportMethod}>
                                <label>
                                    <input type="radio" bind:group={transportMethod} value={true}>
                                    <i class="fas fa-fw fa-truck"></i>
                                    <div class="delivery-text" style="margin-left: 1.05rem;">
                                        <small>Doručiť na adresu</small>
                                        <small>Balík bude doručený na adresu zadanú pri objednávke priamo k vám.</small>
                                    </div>
                                    <span>{(transportCostWillBeChanged)? `od ${transportCost.toFixed(2)}€ (Cena bude upresnená)` : `${transportCost.toFixed(2)}€`}</span>
                                </label>
                            </li>
                            <li class:focused={transportMethod === false}>
                                <label>
                                    <input type="radio" bind:group={transportMethod} value={false}>
                                    <i class="fas fa-fw fa-location-crosshairs"></i>
                                    <div class="delivery-text" style="margin-left: 1.3rem;">
                                        <small>Osobný odber</small>
                                        <small>Do 2-3 dní od potvrdenia objednávky. Osobný odber tovaru je možný na adrese Valaliky, Kostolná 117/18, 044 13.</small>
                                    </div>
                                    <span>Zdarma</span>
                                </label>
                            </li>
                        </ul>
                        <p>Cena dopravy sa môže líšiť v závislosti od hmotnosti/veľkosti pneumatiky.<br>Bližšie informácie nájdete v záložke <a target="_blank" href="#/doprava-a-dodanie">doprava a doba dodania</a>.</p>
                    </div>
                    <div class="order-footer">
                        <div class="footer-text">
                            <div class="float-left">
                                <h2>Celkom:</h2>
                            </div>
                            <div class="float-right">
                                <h2>{calculatePrice($shoppingCart, transportMethod)}€</h2>
                                <p>s DPH</p>
                            </div>
                        </div>
                        <div class="footer-buttons">
                            <button class="btn btn-slate-50" on:click={() => push('/')}>Pokračovať v nákupe</button>
                            <button class="btn btn-primary" disabled={(typeof transportMethod != "boolean")} on:click={() => {if (typeof transportMethod == "boolean") push('/dodacie-udaje')}}>Dodacie údaje<i class="far fa-fw fa-arrow-right-long ml-2"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:catch error}
        <Error/>
    {/await}
</section>

<style>
    .order-products {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        margin-bottom: 1.5rem;
    }
    :global(.order-products .product) {
        border-bottom: 1px solid var(--color-slate-200);
        padding-bottom: 1.25rem;
    }
    :global(.order-products .product .product-image) {
        margin-left: 0 !important;
    }
    :global(.order-products .product .product-right) {
        margin-right: 0 !important;
    }
    .order-delivery {
        padding-top: 1rem;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .order-delivery h2 {
        font-size: 1.3rem;
        font-family: Rubik, sans-serif;
        font-weight: 500;
        color: var(--color-slate-900);
    }
    .order-delivery p {
        font-family: Rubik, sans-serif;
        font-weight: 300;
        padding: 1rem 0;
        font-size: 1rem;
        border-bottom: 1px solid var(--color-slate-200);
    }
    .order-delivery ul {
        margin-top: .5rem;
        list-style-type: none;
        padding-left: 0;
    }
    .order-delivery ul li {
        display: flex;
        border-bottom: 1px solid var(--color-slate-200);
    }
    .order-delivery ul li:first-child {
        border-top: 1px solid var(--color-slate-200);
    }
    .order-delivery ul li label {
        width: 100%;
        padding: 1rem 0;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: 0.1s linear;
        color: var(--color-slate-500);
    }
    .order-delivery ul li.focused label {
        color: var(--color-slate-900);
    }
    .order-delivery ul li label input {
        margin-right: 1rem;
        accent-color: var(--color-primary);
    }
    .order-delivery ul li label i {
        color: var(--color-slate-900);
        font-size: 1.15rem;
    }
    .order-delivery ul li span {
        margin-left: auto;
        font-family: Rubik, sans-serif;
        font-weight: 500;
    }
    .order-delivery .delivery-text {
        display: flex;
        flex-direction: column;
    }
    .order-delivery .delivery-text small {
        font-size: 1rem;
    }
    .order-delivery .delivery-text small:first-child {
        font-weight: 600;
    }
    .order-delivery .delivery-text small:last-child {
        margin-top: .5rem;
        font-size: .9rem;
        padding-right: 2rem;
    }
    .order-footer {
        padding: 1.5rem 0;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .order-footer h2 {
        color: var(--color-slate-900);
        font-family: Rubik, sans-serif;
        font-weight: 500;
    }
    .order-footer p {
        color: var(--color-slate-500);
        font-family: Rubik, sans-serif;
        font-weight: 300;
        text-align: end;
    }
    .order-footer .footer-buttons {
        display: flex;
        flex-flow: row;
        justify-content: end;
        gap: 1rem;
        width: 100%;
        margin-top: 2rem;
    }
    .order-footer .float-left {
        display: flex;
        gap: 0.4rem;
    }
    .order-footer .footer-info i {
        padding-top: 0.3rem;
        font-size: 1.3rem;
    }
    @media (max-width: 575.98px) {
        .order-footer .footer-buttons {
            flex-wrap: wrap;
        }
        .order-footer .footer-buttons button {
            width: 100%;
        }
    }
</style>